import { MapPin } from "lucide-react";
import { AREAS, IMAGES } from "@/data/content";

export default function ServiceAreas() {
  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="relative border-t border-[#262626] overflow-hidden"
    >
      <img
        src={IMAGES.skyline}
        alt="Metro Vancouver skyline — service area for ElectroMax electricians"
        className="absolute inset-0 w-full h-full object-cover opacity-20 grayscale"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]" />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.24em] uppercase text-white/60 mb-4">
              — Service Areas
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold leading-[0.95]">
              We come to you —
              <br />
              <span className="text-white/40">across Metro Vancouver.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg text-white/70 leading-relaxed">
            Serving communities from the North Shore to the Fraser Valley. If
            you&rsquo;re not sure whether we cover your neighborhood, just ask — we
            probably do.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-px bg-[#262626] border border-[#262626]">
          {AREAS.map((a) => (
            <div
              key={a}
              data-testid={`area-${a.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-[#0A0A0A]/90 backdrop-blur px-4 py-5 flex items-center gap-2 group hover:bg-[#141414] transition-colors"
            >
              <MapPin
                className="w-3.5 h-3.5 text-[#E60000] shrink-0"
                strokeWidth={2}
              />
              <span className="text-sm font-semibold tracking-tight text-white/85 group-hover:text-white">
                {a}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
